import { viewSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod";

export const upsertOrderTrackingView = {
  name: "upsertOrderTrackingView" as const,
  input: z.object({ view: viewSchemas["order-tracking-shipments"] }),
  output: z.object({}),
};
